import $ from 'jquery';
import Vue from 'vue';
import App from './app.vue';
import router from './router';
import store from './store';
import BackToTop from 'vue-backtotop';
Vue.config.productionTip = false;
window['$'] = $;
window['jQuery'] = $;
import 'magnific-popup';
Vue.use(BackToTop);
new Vue({
    el: '#app',
    router: router,
    store: store,
    template: '<App/>',
    components: { App: App }
});


// WEBPACK FOOTER //
// ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--2-1!./src/main.ts